module.exports = __webpack_public_path__ + "img/fan-shell.db66ec1c.webp";